import { RangeConverter } from "@cimpress-technology/numeric-ranges";
import RangeType from "../types/RangeTypes";
import { Logger } from "../logging/logger";

export const isInRanges = (value: number | string, ranges: RangeType[]) => {
  try {
    if (ranges && ranges.length > 0) {
      const convertedRanges = RangeConverter.toRanges(ranges);
      return convertedRanges.contains(value).contains;
    } else {
      return false;
    }
  } catch (ex) {
    Logger.instance.error("Exception thrown from isInRanges", {
      error: ex,
      value,
      ranges,
    });
    return false;
  }
};
